export default __webpack_public_path__ + "static/media/iconRecentesNovo.175b6310.svg";